<template>
  <div class="me-page">
    <header>
      <img src="@/assets/imgs/product_logo.png" alt />
      <div>{{ custerName }}</div>
      <div style="margin-top: 10px">{{ jobNumber }}</div>
      <div style="margin-top: 10px">(卡余额：{{ balance }} 元)</div>
    </header>
    <main>
      <div class="headerTop">
        <div class="headerTop-title">你的BMI</div>
        <div class="headerTop-bmi">
          <div class="headerTop-bmi-num">{{ userInfo.userBmi }}</div>
          <div class="headerTop-bmi-text">
            {{ userInfo.bmiName }}
          </div>
        </div>
        <div>
          <progressBar :number="userInfo.userBmi" />
        </div>
      </div>
      <van-cell-group>
        <template v-for="(item, index) in configData">
          <van-cell
            :title="item.name"
            :key="index"
            :to="item.url"
            is-link
            v-if="!item.isHide"
          >
            <img
              slot="icon"
              class="me-icon"
              v-if="item.img"
              :src="item.img"
              alt
            />
          </van-cell>
        </template>
        <!-- <van-cell title="修改密码" is-link @click="$router.push('/repass')" v-if="showQueit == '1'">
          <img
            slot="icon"
            class="me-icon"
            src="@/assets/2018-05-27-icon_me_guanyu@2x.png"
            alt
          />
        </van-cell> -->
        <!-- <van-cell
          title="修改密码"
          @click="$router.push('/repass')"
          is-link
        ></van-cell> -->
        <van-cell
          title="切换员工登录"
          v-if="showQueit != '1'"
          @click="handleQuit"
          is-link
        ></van-cell>
        <van-cell
          title="退出员工登录"
          v-if="showQueit == '1'"
          @click="handleQuitUser"
          is-link
        ></van-cell>
      </van-cell-group>
    </main>
  </div>
</template>

<script>
import progressBar from "./components/progressBar.vue";
import { getUserHealthyProfile } from "@/apis/stems.js";
export default {
  components: {
    progressBar,
  },
  data() {
    return {
      configData: [
        // {
        //   img: require("@/assets/2018-05-27-icon_me_guanyu@2x.png"),
        //   name: "地址管理",
        //   url: "/merchants/adminAdress",
        // },
        {
          img: require("@/assets/2018-05-27-icon_me_guanyu@2x.png"),
          name: "充值",
          url: "/range",
          isHide: localStorage.getItem("showQuit") != '1'
        },
        {
          img: require("@/assets/2018-05-27-icon_me_guanyu@2x.png"),
          name: "人脸列表",
          url: "/face/index",
          isHide: localStorage.getItem('loginType') != 'user'
        },
        {
          img: require("@/assets/2018-05-27-nutition@2x.png"),
          name: "健康档案",
          url: "/recordsHealth",
        },
      ],
      userInfo: {
        name: "00",
        userBmi: 15,
        age: "0",
        weight: "0",
        height: "0",
        photo: require("../../assets/image/B6.png"),
      },
      custerName: "",
      balance: "",
      shopId: "",
      customerId: "",
      showQueit: "",
      custerPhone: "",
      jobNumber: ''
    };
  },
  created() {
    this.shopId = localStorage.getItem("shopId");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
  },
  mounted() {
    this.showQueit = localStorage.getItem("showQuit") || "";
    this.getBalance();
    this.getUserHealthyProfileFun();
  },
  methods: {
    handleQuit() {
      localStorage.removeItem("customerInfoList");
      localStorage.removeItem('userName');
      localStorage.removeItem('studentNo');
      localStorage.removeItem('hidePatientLogin');
      this.$router.replace({
        path: "/login",
      });
      // sessionStorage.clear();
      // localStorage.clear();
      // localStorage.removeItem("password");
    },
    handleQuitUser() {
      localStorage.removeItem('loginType');
      localStorage.removeItem('userName');
      localStorage.removeItem('studentNo');
      localStorage.removeItem('hidePatientLogin');
      this.$router.replace({
        path: "/login",
      });
    },
    getBalance() {
      let data = {
        shopId: this.shopId,
        customerId: this.customerId || 0,
      };
      this.$logina.post("/api/customer/getBalanceV3", data).then((res) => {
        let { data } = res.data;
        this.balance = (data.balance / 100).toFixed(2);
        this.custerName = data.customerName;
        this.jobNumber = data.phone
        this.custerPhone = data.phone;
        localStorage.setItem("customerName", data.customerName);
        localStorage.setItem("userPhone", data.phone);
        localStorage.setItem("cardNo", data.cardNo);
      });
    },

    getUserHealthyProfileFun() {
      getUserHealthyProfile({
        userCode: this.customerId,
      }).then((res) => {
        if (res.data.data == null) {
          this.show = true;
          return;
        }
        this.userInfo = res.data.data;
        this.userInfo.age = this.jsGetAge(this.userInfo.birthday) || 0;
        this.userInfo.name = sessionStorage.getItem("userName");
        this.userInfo.photo =
          sessionStorage.getItem("userimg") ||
          require("../../assets/image/B6.png");
        this.userInfo.userBmi < 18.5
          ? (this.userInfo.bmiName = "消瘦")
          : this.userInfo.userBmi < 25
          ? (this.userInfo.bmiName = "正常")
          : this.userInfo.userBmi < 30
          ? (this.userInfo.bmiName = "超重")
          : (this.userInfo.bmiName = "肥胖");
        // this.userInfo.photo = require("../../assets/image/B6.png");
      });
    },
    jsGetAge(strBirthday) {
      strBirthday = new Date(strBirthday.replace(/-/g, "/"));
      var d = new Date();
      var age =
        d.getFullYear() -
        strBirthday.getFullYear() -
        (d.getMonth() < strBirthday.getMonth() ||
        (d.getMonth() == strBirthday.getMonth() &&
          d.getDate() < strBirthday.getDate())
          ? 1
          : 0);
      return age;
    },
    //
    handleCoupinsList() {
      let locationId = localStorage.getItem("locationId");
      if (locationId == "null" || locationId == undefined) {
        locationId = "";
      }
      window.location.href = `https://gszyy.yunpengai.com/cdh5/#/?shopId=${localStorage.getItem(
        "shopId"
      )}&customerId=${this.customerId}&couponCode=${locationId}&userName=${
        this.custerName
      }&phone=${this.custerPhone}&type=1`;
    },
  },
};
</script>
<style lang="scss">
.me-page {
  .van-cell {
    align-items: center;
  }
}
</style>
<style lang="scss" scoped>
.me-page {
  min-height: 100%;
  background-color: #f8f8f8;
  .me-icon {
    width: 32px;
    height: 32px;
    margin-right: 5px;
  }
  header {
    padding: 24px 40px;
    text-align: center;
    background-color: #fff;
    font-size: 16px;
    color: #333;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-bottom: 10px;
      background-color: rgb(253, 234, 234);
    }
  }
  main {
    margin-top: 24px;
    background-color: #fff;
  }
  .headerTop {
    width: 343px;
    height: 169px;
    margin: 0 auto 10px auto;
    padding: 15px;
    box-sizing: border-box;
    background: #ffffff;
    position: relative;
    &-title {
      font-size: 17px;
      font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
      font-weight: 400;
      color: #202020;
      position: relative;
    }
    &-title::before {
      content: "";
      height: 16px;
      width: 2px;
      background-color: #4bd891;
      position: absolute;
      left: -7px;
      top: 3px;
    }
    &-bmi {
      display: flex;
      &-num {
        font-size: 24px;
        font-weight: 400;
        color: #202020;
        margin: 15px 5px 0 15px;
      }
      &-text {
        font-size: 13px;
        font-weight: 400;
        color: #59d5a0;
        margin-top: 25px;
      }
    }
  }
}
</style>
